import { EMPTY_OPTION_VALUE as t } from "../../../constants/index.js";

class s {
    valueHash=0;
    root;
    _options=[];
    _values=[];
    constructor(t) {
        this.root = t;
    }
    indexOf(t) {
        return this._values.indexOf(this.root.getOptionValue(t));
    }
    at(t) {
        return this._options[t];
    }
    has(t) {
        return -1 !== this.indexOf(t);
    }
    map(t) {
        return this._options.map(t);
    }
    find(t) {
        return this._options.find(t);
    }
    differentByValue(t) {
        if (t.length !== this.length) return !0;
        for (let s = 0; s < t.length; s++) if (this._values[s] !== this.root.getOptionValue(t[s])) return !0;
        return !1;
    }
    get value() {
        const s = this.root.rawValueMode ? this._options : this._values;
        return this.root.multiple ? [ ...s ] : s.length ? s[0] : t;
    }
    initialize(t) {
        this._options = [ ...t ], this._values = t.map((t => this.root.getOptionValue(t))), 
        this._changeValueHash();
    }
    _addRaw(t, s) {
        this._options.push(t), this._values.push(s), this._changeValueHash();
    }
    _changeValueHash() {
        this.valueHash = this.valueHash + 1 & 65535;
    }
    toggle(t) {
        const s = this.root.getOptionValue(t), e = this._values.indexOf(s);
        -1 === e ? this._addRaw(t, s) : (this._options.splice(e, 1), this._values.splice(e, 1), 
        this._changeValueHash()), this._changeValueHash();
    }
    add(t) {
        const s = this.root.getOptionValue(t);
        this._values.includes(s) || this._addRaw(t, s);
    }
    clear() {
        this._options.splice(0), this._values.splice(0), this._changeValueHash();
    }
    get length() {
        return this._options.length;
    }
}

export { s as default };
//# sourceMappingURL=index.js.map
